<a [href]="pdfLink()" class="link-pdf-file" target="_blank">
        <span class="material-symbols-outlined">docs</span>
        <span class="txt-rule">{{ 'header.txtRule' | translate }}</span>
</a>
